import deepmerge from 'deepmerge';
import {
  brandSpecific,
  localeSpecificGroup,
  LocaleSpecificGroup,
} from 'utils/override';
import {
  BRAND_SPECIFIC_FLAG_KEY,
  BRAND_SPECIFIC_FLAG_VALUE,
  BrandSpecificWithFlag,
} from 'utils/staticText';
import { ClientContext } from '../context/client';
import { deepmergeOptions } from './deepmergeOptions';

const resolveLocaleSpecificGroup = <T>(
  group: LocaleSpecificGroup<T> | BrandSpecificWithFlag<LocaleSpecificGroup<T>>,
  context: ClientContext,
): LocaleSpecificGroup<T> => {
  if (
    BRAND_SPECIFIC_FLAG_KEY in group &&
    group[BRAND_SPECIFIC_FLAG_KEY] === BRAND_SPECIFIC_FLAG_VALUE
  ) {
    const brandSpecificGroup = brandSpecific(group).get(context.brand);
    return deepmerge<LocaleSpecificGroup<T>>(
      group._,
      brandSpecificGroup ?? {},
      deepmergeOptions,
    );
  } else {
    return group as LocaleSpecificGroup<T>;
  }
};

export function getClientTranslations<T>(
  group: LocaleSpecificGroup<T> | BrandSpecificWithFlag<LocaleSpecificGroup<T>>,
  context: ClientContext,
): T {
  const keys = resolveLocaleSpecificGroup(group, context);

  const staticText = localeSpecificGroup(keys).get(context.lang);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- sneaky patch
  (staticText as any).toJSON = () => {
    // Throw an error when all keys are being sent to the client (experimental_taintObjectReference)
    throw new Error(
      'Do not pass all static keys to the client. Use filterKeys.',
    );
  };
  return staticText;
}
